import { PayloadAction } from '@reduxjs/toolkit';
import { AxiosResponse } from 'axios';
import { call, put } from 'redux-saga/effects';

import { rikHttpClient } from 'services/httpClient';
import ICreateThreadMessageInterventionRequestBody from 'services/httpClient/requests/intervention/ICreateThreadMessageInterventionRequestBody';
import ICreateThreadMessageInterventionResponse from 'services/httpClient/responses/intervention/ICreateThreadMessageInterventionResponse';

import { interventionActions } from '../index';
import { ICreateThreadMessageRequestAction } from '../reducers/createThreadMessage/request';

function* createThreadMessage(
  action: PayloadAction<ICreateThreadMessageRequestAction>,
) {
  try {
    const body: ICreateThreadMessageInterventionRequestBody = {
      text: action.payload.data.text,
      thread_message_id: action.payload.data.threadMessageId,
      wrote_by: 'trader',
    };

    const { data }: AxiosResponse<ICreateThreadMessageInterventionResponse> =
      yield call(rikHttpClient.post, `messages/message`, body);

    yield put(
      interventionActions.createThreadMessageSuccess({
        message: data,
        threadMessageId: action.payload.data.threadMessageId,
      }),
    );
    action.payload.functions.closeModal();
  } catch (err: any) {
    action.payload.functions.error(err);

    yield put(interventionActions.createThreadMessageFailure());
  }
}

export default createThreadMessage;
